import { formatBRL } from "../money";

// Código curto do lead: 4 caracteres sem ambiguidade (sem I, O, 0 e 1).
export const LEAD_CODE_ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
export const LEAD_CODE_LENGTH = 4;

export function generateLeadCode(randomInt: (max: number) => number = cryptoRandomInt): string {
  let code = "";
  for (let i = 0; i < LEAD_CODE_LENGTH; i++) {
    code += LEAD_CODE_ALPHABET[randomInt(LEAD_CODE_ALPHABET.length)];
  }
  return code;
}

export function isLeadCode(value: string): boolean {
  return new RegExp(`^[${LEAD_CODE_ALPHABET}]{${LEAD_CODE_LENGTH}}$`).test(value);
}

function cryptoRandomInt(max: number): number {
  const buf = new Uint32Array(1);
  // Rejeição para evitar viés de módulo.
  const limit = Math.floor(0x1_0000_0000 / max) * max;
  for (;;) {
    globalThis.crypto.getRandomValues(buf);
    const v = buf[0] ?? 0;
    if (v < limit) return v % max;
  }
}

export const LEAD_STATUSES = [
  "new",
  "in_conversation",
  "link_sent",
  "won",
  "lost",
  "no_reply",
] as const;
export type LeadStatus = (typeof LEAD_STATUSES)[number];

export const LEAD_STATUS_LABELS: Record<LeadStatus, string> = {
  new: "Novo",
  in_conversation: "Em conversa",
  link_sent: "Link enviado",
  won: "Ganho",
  lost: "Perdido",
  no_reply: "Sem resposta",
};

export const LOST_REASONS = [
  "price",
  "schedule",
  "no_reply",
  "competitor",
  "gave_up",
  "other",
] as const;
export type LostReason = (typeof LOST_REASONS)[number];

export const LOST_REASON_LABELS: Record<LostReason, string> = {
  price: "Preço",
  schedule: "Horário",
  no_reply: "Não respondeu",
  competitor: "Concorrente",
  gave_up: "Desistiu",
  other: "Outro",
};

/** Transições permitidas pela vendedora (as automáticas ficam nos jobs e na ativação). */
export function canMoveLead(from: LeadStatus, to: LeadStatus): boolean {
  if (from === to) return true;
  if (from === "won") return false;
  switch (to) {
    case "in_conversation":
      return from === "new" || from === "lost" || from === "no_reply" || from === "link_sent";
    case "lost":
      return true;
    case "link_sent":
      return from === "new" || from === "in_conversation" || from === "no_reply";
    case "won":
      return from === "link_sent";
    case "no_reply":
      return from === "new" || from === "in_conversation";
    case "new":
      return false;
  }
}

/** Mensagem pronta do WhatsApp com o código do lead. */
export function whatsappGreeting(priceCents: number, code: string): string {
  return `Olá! Quero garantir minha vaga por ${formatBRL(priceCents)} (código ${code})`;
}

/** Zera os dois últimos octetos de um IPv4 (e anonimiza IPv6 em /32). */
export function anonymizeIp(ip: string | null | undefined): string | null {
  if (!ip) return null;
  const v4 = ip.replace(/^::ffff:/, "");
  const parts = v4.split(".");
  if (parts.length === 4) return `${parts[0]}.${parts[1]}.0.0`;
  if (ip.includes(":")) {
    const groups = ip.split(":");
    return `${groups.slice(0, 2).join(":")}::`;
  }
  return null;
}
